// Tiny prefill bridge between Home Show staff capture flows and the
// /free-home-assessment form. Any flow can call setAssessmentPrefill(data)
// before navigating, and the assessment page will consume the data on mount.
//
// Storage: sessionStorage (per-tab, clears on tab close) — appropriate for
// in-show staff capture where the same browser tab is used by the rep.
const KEY = "aeromax_assessment_prefill";

export function setAssessmentPrefill(data) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(data || {}));
  } catch {
    /* sessionStorage unavailable — ignore */
  }
}

// Returns the stored prefill object (or null). Does NOT clear by default so
// the user can still navigate away and back without losing the data. Use
// `clearAssessmentPrefill()` after successful submit.
export function getAssessmentPrefill() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearAssessmentPrefill() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
